import { FunctionComponent, PropsWithChildren } from 'react';

export const CenteredLayout: FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  return (
    <div className="flex min-h-screen">
      <div className="mx-auto my-auto">
        <div className="max-w-512 sm:min-w-512 border-grey-200 mx-m rounded-lg border bg-white p-xl shadow-m sm:p-xxxl">
          {children}
        </div>
      </div>
    </div>
  );
};
